import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.date.to-string.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FHTDeviceType, MessageIOType } from "@/models/MessageTypes";
import { isMarker } from "@/store/chat/messages/messagesWithMarker";
import { UrlHelperExtensions } from "@/url_helpers";
import { ProductAndServiceMenuTypeEnum } from "@/apis/model/ProductAndServiceMenuTypeEnum";
export default function ChatStatus(props) {
  var myself = props.myself,
      currentContactMessages = props.currentContactMessages;
  var now = new Date();
  var deviceType = FHTDeviceType.All;

  if (currentContactMessages.length) {
    for (var curr = 0; curr < currentContactMessages.length; curr++) {
      var msg = currentContactMessages[curr];
      if (isMarker(msg)) continue;

      if (msg && msg.MessageIOType === MessageIOType.Received || msg.timestamp.getTime() < now.getTime() - 120 * 1000) {
        deviceType = msg.deviceType;
        break;
      }
    }
  }

  if ((deviceType === FHTDeviceType.Android || deviceType === FHTDeviceType.Ios) && !myself.isMobileUser) {
    return _jsxs("div", __assign({
      className: "chat-box__main-device-type"
    }, {
      children: [_jsx("span", __assign({
        className: "chat-box__main-device-type-tip"
      }, {
        children: "\u5BF9\u65B9\u6B63\u5728\u4F7F\u7528\u79FB\u52A8APP\u4E0E\u4F60\u804A\u5929"
      }), void 0), myself && _jsx("a", __assign({
        href: UrlHelperExtensions.$OfficialSiteProductUrl(ProductAndServiceMenuTypeEnum.AppDownload, undefined),
        target: "_blank",
        className: "chat-box__main-download"
      }, {
        children: "\u7ACB\u5373\u4E0B\u8F7D"
      }), void 0)]
    }), void 0);
  }

  return null;
}